/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ICipQuickLinkProps, iconBefore } from './cip-quick-link.props.autogenerated';

export interface ICipQuickLinkViewProps extends ICipQuickLinkProps<{}> {
    iconBefore: iconBefore | undefined;
    ariaLabel: string | undefined;
    target: string | undefined;
    text: string | undefined;
    href: string | undefined;
    className: string;
}

/**
 *
 * CipQuicklink component
 * @extends {React.PureComponent<ICipQuickLinkProps<ICipQuickLinkData>>}
 */
class CipQuicklink extends React.PureComponent<ICipQuickLinkViewProps> {
    private readonly getCipQuicklinkProps = (): ICipQuickLinkViewProps => {
        const {
            config: { iconBefore, link }
        } = this.props;
        const className = 'cip-quick-link';

        return {
            ...this.props,
            ariaLabel: link?.ariaLabel,
            text: link?.linkText,
            target: link?.openInNewTab ? '_blank' : undefined,
            href: link?.linkUrl && link?.linkUrl.destinationUrl ? link?.linkUrl?.destinationUrl : undefined,
            iconBefore: iconBefore,
            className: className,
            resources: this.props.resources
        };
    };

    public render(): JSX.Element | null {
        return this.props.renderView(this.getCipQuicklinkProps());
    }
}

export default CipQuicklink;
